import { Suspense, lazy } from "react";

const ApprovalsPage = lazy(() => import("../Approvals/ApprovalsPage"));
const WorkspaceMyWorkPanel = lazy(() => import("./WorkspaceMyWorkPanel"));
const WorkspaceDeskTargetsPanel = lazy(() => import("./WorkspaceDeskTargetsPanel"));
const WorkspaceHubTodayPanel = lazy(() => import("./WorkspaceHubTodayPanel"));
const WorkspaceHubAssignPanel = lazy(() => import("./WorkspaceHubAssignPanel"));
const WorkspaceSetTargetsPanel = lazy(() => import("./WorkspaceSetTargetsPanel"));
const WorkspacePerformancePanel = lazy(() => import("./WorkspacePerformancePanel"));
const WorkspaceRingBellsPanel = lazy(() => import("./WorkspaceRingBellsPanel"));

function DeskPerformance() {
  return <WorkspacePerformancePanel mode="desk" />;
}

function HubPerformance() {
  return <WorkspacePerformancePanel mode="hub" />;
}

const MAP = {
  deskWork: WorkspaceMyWorkPanel,
  deskTargets: WorkspaceDeskTargetsPanel,
  deskPerformance: DeskPerformance,
  hubToday: WorkspaceHubTodayPanel,
  hubAssign: WorkspaceHubAssignPanel,
  hubTargets: WorkspaceSetTargetsPanel,
  hubRingBells: WorkspaceRingBellsPanel,
  hubPerformance: HubPerformance,
  approvals: ApprovalsPage,
};

function SectionFallback() {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center text-sm text-gray-500">
      Loading workspace…
    </div>
  );
}

export default function WorkspaceSectionBody({ componentKey, onGo }) {
  const Comp = MAP[componentKey];
  if (!Comp) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-800">
        This section is not available.
      </div>
    );
  }
  return (
    <Suspense fallback={<SectionFallback />}>
      <div className="workspace-embed min-w-0">
        <Comp onGo={onGo} />
      </div>
    </Suspense>
  );
}
